import { FC } from 'react';
import { Link as MaterialLink, LinkProps as MuiLinkProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { EMPTY_FUNCTION } from '@uplift/constants';


const useStyles = makeStyles()(() => ({
  root: {
    fontWeight: 450,
    fontSize: '14px',
    lineHeight: '175%',
    letterSpacing: '0.15px',
    color: '#A63287',
    '&:visited': {
      color: '#74005A'
    },
    '&:hover': {
      color: '#DA64B7',
    },

    textDecorationColor: 'currentColor',
  },
}));


export type LinkProps = MuiLinkProps & Pick<RouterLinkProps, 'to' | 'replace'> & {
  className?: string;
  onClick?: () => void;
};


export const Link: FC<LinkProps> = ({ children, className = '', onClick = EMPTY_FUNCTION, underline = 'always', ...props }) => {
  const { classes, cx } = useStyles();

  return (
    <MaterialLink
      classes={{
        root: classes.root
      }}
      onClick={onClick}
      component={RouterLink}
      className={cx(className)}
      underline={underline}
      {...props}
    >
      {children}
    </MaterialLink>
  );
};
